module.exports = __webpack_public_path__ + "static/img/Crane.bfe56e9d.png";